<template>
  <div class="history-page">
    <!-- 顶部横幅 -->
    <div class="history-banner">
      <div class="banner-content" data-aos="fade-down">
        <h1>历史成绩</h1>
        <p>卓越成就 · 艺术传承</p>
        <div class="banner-badges">
          <span class="badge">统考高分</span>
          <span class="badge">升学保障</span>
          <span class="badge">口碑见证</span>
        </div>
      </div>
    </div>

    <!-- 面包屑导航 -->
    <div class="breadcrumb">
      <div class="container">
        <router-link to="/">首页</router-link>
        <span> / </span>
        <span>历史成绩</span>
      </div>
    </div>

    <div class="container">
      <!-- 我们的成绩 -->
      <section class="history-section our-achievements" data-aos="fade-up">
        <div class="section-header">
          <h2>我们的成绩</h2>
          <div class="divider"></div>
          <p class="section-description">二十余年来，杉原美术学校学子取得的各类统考、校考优异成绩</p>
        </div>
        <div class="achievements-timeline">
          <div class="achievement-item" v-for="(item, index) in achievements" :key="index"
               :data-aos="index % 2 === 0 ? 'fade-right' : 'fade-left'" :data-aos-delay="index * 10">
            <div class="achievement-year">{{ item.year }}</div>
            <div class="achievement-content">{{ item.description }}</div>
          </div>
        </div>
      </section>

      <!-- 成绩概览 -->
      <section v-if="false" class="history-section overview">
        <div class="section-header">
          <h2>成绩概览</h2>
          <div class="divider"></div>
          <p class="section-description">我校学生在各类艺术考试和专升本考试中取得了优异成绩</p>
        </div>
        <div class="overview-cards">
          <div class="overview-card">
            <div class="card-icon">
              <i class="fas fa-graduation-cap"></i>
            </div>
            <div class="card-content">
              <h3>专升本录取率</h3>
              <div class="card-value">95%</div>
              <div class="card-trend positive">
                <i class="fas fa-arrow-up"></i> 较往年提升
              </div>
            </div>
          </div>
          <div class="overview-card">
            <div class="card-icon">
              <i class="fas fa-award"></i>
            </div>
            <div class="card-content">
              <h3>艺考合格率</h3>
              <div class="card-value">92%</div>
              <div class="card-trend positive">
                <i class="fas fa-arrow-up"></i> 行业领先
              </div>
            </div>
          </div>
          <div class="overview-card">
            <div class="card-icon">
              <i class="fas fa-trophy"></i>
            </div>
            <div class="card-content">
              <h3>重点院校录取</h3>
              <div class="card-value">108</div>
              <div class="card-description">人次</div>
            </div>
          </div>
          <div class="overview-card">
            <div class="card-icon">
              <i class="fas fa-university"></i>
            </div>
            <div class="card-content">
              <h3>毕业生就业率</h3>
              <div class="card-value">98%</div>
              <div class="card-trend positive">
                <i class="fas fa-arrow-up"></i> 稳定增长
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 历年毕业照 -->
      <section class="history-section graduation-photos" data-aos="fade-up">
        <div class="section-header">
          <h2>历年毕业照</h2>
          <div class="divider"></div>
          <p class="section-description">记录每一届学子的青春与成长</p>
        </div>
        <div class="photo-gallery">
          <!--:data-aos="'zoom-in'" :data-aos-delay="index * 40"-->
          <div class="photo-item shiny" v-for="(photo, index) in graduationPhotos" :key="index" @click="openPhotoModal(photo)">
            <div class="photo-container">
              <img :src="photo.image" :alt="photo.year + '毕业照'" loading="lazy">
              <div class="photo-overlay">
                <div class="photo-year">{{ photo.year }}</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 专升本成绩 -->
      <section class="history-section achievement" data-aos="fade-up" v-if="false">
        <div class="section-header">
          <h2>2025届优异成绩展示</h2>
          <!--<div class="divider"></div>-->
          <!--<p class="section-description">25届专升本考试优异成绩展示</p>-->
        </div>
        <div class="achievement-content">
          <div class="achievement-grid">
            <!--data-aos="zoom-in" :data-aos-delay="index * 25"-->
            <div class="achievement-item" v-for="(item, index) in gaokaoItemsVisible" :key="index" @click="openAchievementModal(item, index)">
              <!--<img :src="item.image" :alt="'高考录取喜报 ' + (index + 1)" loading="lazy">-->
              <img :src="require(`@/assets/resources/历史成绩/25年高考录取喜报/${index + 1}.png`)" :alt="'高考录取喜报 ' + (index + 1)" loading="lazy">
            </div>
          </div>
          <div class="load-more" v-if="visibleAchievements < gaokaoItems.length">
            <button class="btn btn-outline" @click="loadMoreAchievements">加载更多</button>
          </div>
          <div class="load-sentinel" ref="achievementsSentinel" aria-hidden="true"></div>
        </div>
      </section>
    </div>

    <!-- 照片查看模态框（移动端等比 contain，避免变形） -->
    <transition name="modal-fade-zoom">
      <div class="photo-modal" v-if="selectedPhoto" @click="closePhotoModal">
        <div class="modal-content" @click.stop>
          <span class="close-button" @click="closePhotoModal">&times;</span>
          <img :src="selectedPhoto.image" :alt="selectedPhoto.year + '届毕业照'" loading="lazy" class="responsive-preview">
          <!--<div class="modal-caption">{{ selectedPhoto.year }}届毕业照</div>-->
        </div>
      </div>
    </transition>

    <!-- 成绩查看模态框 -->
    <transition name="modal-fade-zoom">
      <div class="achievement-modal" v-if="selectedAchievement" @click="closeAchievementModal">
        <div class="modal-content" @click.stop>
          <span class="close-button" @click="closeAchievementModal">&times;</span>
          <img :src="require(`@/assets/resources/历史成绩/25年高考录取喜报/${selectedAchievement.index + 1}.png`)" :alt="selectedAchievement.title" loading="lazy">
          <!--<div class="modal-caption">{{ selectedAchievement.title }}</div>-->
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "HistoryPage",
  data() {
    return {
      visibleAchievements: 12,
      achievementsStep: 12,
      activeTab: 'zhuanshengben',
      selectedPhoto: null,
      selectedAchievement: null,
      achievements: [
        { year: 2003, description: '杉原画室成立。' },
        { year: 2004, description: '王旭峰同学以273.5的总分考取山西省统考最高分。' },
        { year: 2005, description: '牛山红同学、南芳同学在山西省统考中名列前茅。' },
        { year: 2006, description: '秦丽同学以269.7分考取长治市最高分。' },
        { year: 2007, description: '全市统考前二十名，我校独占六名。' },
        { year: 2008, description: '林伟静同学271.1分再次考取山西省超高分。' },
        { year: 2009, description: '统考240分以上同学达56人。' },
        { year: 2010, description: '张露、任鹏飞同学以256.3分在山西省统考中名列前茅。' },
        { year: 2012, description: '任越同学在山西美术统考中考取262.7分超高分。' },
        { year: 2013, description: '荣周涛同学再次以270分的优异成绩考取山西省统考超高分。' },
        { year: 2014, description: '我校5名同学在山西美术统考中名列前茅。' },
        { year: 2015, description: '参加考试215人，专业合格213人。' },
        { year: 2016, description: '统考再创佳绩，在校中八大美院合格证达16个。' },
        { year: 2017, description: '统考又创佳绩，校考中收获213个合格证。' },
        { year: 2018, description: '山西统考250分以上2人。' },
        { year: 2019, description: '山西统考我校最高分254.33分，230分以上46人，220分以上158人，平均分223分！' },
        { year: 2020, description: '山西美术统考中，我校均分212分，所有学生全部达到合格线。' },
        { year: 2021, description: '山西统考我校最高分253.4分，230分以上18人，220分以上69人。' },
        { year: 2022, description: '山西省统考250分以上两名，222分以上达148人，达线率83%。' },
        { year: 2023, description: '山西省统考250分以上两名，最高分253.4分，达线率83%。' },
        { year: 2024, description: '山西省统考我校最高分254分，210分以上231人，达线率94.5%。' },
        { year: 2025, description: '山西省统考我校最高分253.2分，画室共180人，172人达本科线，230分以上51人，本科通过率96%。' }
      ],
      graduationPhotos: [
        {
          year: '2025届',
          image: require('@/assets/resources/往年毕业照摘录/杉原学校2025集体照.jpg')
        },
        {
          year: '2025届专升本',
          image: require('@/assets/resources/往年毕业照摘录/专升本合照2025届.jpg')
        },
        {
          year: '2024届',
          image: require('@/assets/resources/往年毕业照摘录/2024.jpg')
        },
        {
          year: '2022届',
          image: require('@/assets/resources/往年毕业照摘录/2022.jpg')
        },
        {
          year: '2021届',
          image: require('@/assets/resources/往年毕业照摘录/2021.jpg')
        },
        {
          year: '2020届',
          image: require('@/assets/resources/往年毕业照摘录/2020届毕业照.jpg')
        },
        {
          year: '2019届',
          image: require('@/assets/resources/往年毕业照摘录/2019.jpg')
        },
        {
          year: '2015届',
          image: require('@/assets/resources/往年毕业照摘录/2015.jpg')
        },
        {
          year: '2014届',
          image: require('@/assets/resources/往年毕业照摘录/2014.jpg')
        }
      ],
      // zhuanshengbenItems: Array.from({ length: 20 }, (_, i) => ({
      //   id: i + 1,
      //   title: `专升本喜报 ${i + 1}`,
      //   image: require(`@/assets/resources/历史成绩/25届专升本喜报/${i + 1}.png`)
      // })),
      gaokaoItems: Array.from({ length: 108 }, (_, i) => ({
        id: i + 1,
        title: `高考录取喜报 ${i + 1}`,
        // image: require(`@/assets/resources/历史成绩/25年高考录取喜报/${i + 1}.png`)
      }))
    };
  },
  methods: {
    loadMoreAchievements() {
      this.visibleAchievements = Math.min(this.visibleAchievements + this.achievementsStep, this.gaokaoItems.length)
    },
    openPhotoModal(photo) {
      this.selectedPhoto = photo;
      document.body.style.overflow = 'hidden';
    },
    closePhotoModal() {
      this.selectedPhoto = null;
      document.body.style.overflow = 'auto';
    },
    openAchievementModal(achievement, index) {
      achievement.index = index
      this.selectedAchievement = achievement;
      document.body.style.overflow = 'hidden';
    },
    closeAchievementModal() {
      this.selectedAchievement = null;
      document.body.style.overflow = 'auto';
    }
  },
  computed: {
    gaokaoItemsVisible() {
      return this.gaokaoItems.slice(0, this.visibleAchievements)
    }
  },
  mounted() {
    // const s = this.$refs.achievementsSentinel
    // if (s && 'IntersectionObserver' in window) {
    //   const ob = new IntersectionObserver((entries) => {
    //     entries.forEach(e => { if (e.isIntersecting) this.loadMoreAchievements() })
    //   }, { rootMargin: '200px' })
    //   ob.observe(s)
    //   this._achievementsObserver = ob
    // }
  },
  beforeDestroy() {
    // if (this._achievementsObserver) this._achievementsObserver.disconnect()
  }
};
</script>

<style scoped lang="scss">
.history-page {
  background-color: #f9f9f9;
}

.history-banner {
  background-image: linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url('@/assets/images/common-banner.jpg');
  background-size: cover;
  background-position: center;
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  text-align: center;
}
.banner-badges { margin-top: 12px; display: inline-flex; gap: 10px; }
.badge { padding: 6px 10px; border-radius: 999px; font-size: 12px; letter-spacing: 0.06em; background: rgba(255,255,255,0.14); border: 1px solid rgba(255,255,255,0.22); }

.banner-content h1 {
  font-size: 3rem;
  margin-bottom: 1rem;
  font-weight: 700;
}

.banner-content p {
  font-size: 1.2rem;
  opacity: 0.9;
}

.breadcrumb { background: transparent; padding: 12px 0; margin: 10px 0 24px; font-size: 0.95rem; }
.breadcrumb a { color: var(--default-red-color); text-decoration: none; }
.breadcrumb a:hover { text-decoration: underline; }
.breadcrumb span { color: #9aa6ac; margin: 0 5px; }

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px;
}

.history-section {
  margin: 50px 0;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  padding: 30px;
}

.section-header {
  text-align: center;
  margin-bottom: 30px;
}

.section-header h2 {
  font-size: 2rem;
  color: #333;
  margin-bottom: 10px;
}

.divider {
  height: 3px;
  width: 60px;
  background-color: #e74c3c;
  margin: 0 auto 15px;
}

.section-description {
  color: #666;
  max-width: 700px;
  margin: 0 auto;
}

/* 成绩概览卡片 */
.overview-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-top: 30px;
}

.overview-card {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1);
  padding: 25px;
  display: flex;
  align-items: center;
  transition: transform 0.3s ease;
}

.overview-card:hover {
  transform: translateY(-5px);
}

.card-icon {
  background-color: #f8f9fa;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 20px;
  color: #e74c3c;
  font-size: 1.5rem;
}

.card-content h3 {
  font-size: 1rem;
  color: #666;
  margin-bottom: 5px;
}

.card-value {
  font-size: 1.8rem;
  font-weight: 700;
  color: #333;
  margin-bottom: 5px;
}

.card-trend {
  font-size: 0.85rem;
  display: flex;
  align-items: center;
}

.card-trend.positive {
  color: #28a745;
}

.card-trend.negative {
  color: #dc3545;
}

.card-trend i {
  margin-right: 5px;
}

.card-description {
  font-size: 0.85rem;
  color: #666;
}

/* 毕业照相册 */
.photo-gallery {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 20px;
  margin-top: 30px;
}

.photo-item {
  cursor: pointer;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
}
//.photo-item.shiny::after { content: ''; position: absolute; top: -120%; left: -120%; width: 220%; height: 220%; background: linear-gradient(120deg, rgba(255,255,255,0) 42%, rgba(255,255,255,0.5) 50%, rgba(255,255,255,0) 58%); transform: rotate(10deg); transition: transform 0.6s ease, opacity 0.6s ease; opacity: 0; }
//.photo-item.shiny:hover::after { transform: rotate(10deg) translate(18%,18%); opacity: 1; }

.photo-item:hover {
  transform: scale(1.03);
}

.photo-container {
  position: relative;
  padding-top: 75%; /* 4:3 Aspect Ratio */
}

.photo-container img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.photo-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(transparent, rgba(0, 0, 0, 0.7));
  padding: 15px;
  color: white;
}

.photo-year {
  font-size: 1.2rem;
  font-weight: 600;
}

/* 成绩展示 */
.achievement-tabs {
  display: flex;
  justify-content: center;
  margin-bottom: 30px;
  border-bottom: 1px solid #eee;
}

.tab-button {
  background: none;
  border: none;
  padding: 10px 20px;
  font-size: 1rem;
  cursor: pointer;
  position: relative;
  color: #666;
  transition: color 0.3s;
}

.tab-button:hover {
  color: #e74c3c;
}

.tab-button.active {
  color: #e74c3c;
  font-weight: 600;
}

.tab-button.active::after {
  content: '';
  position: absolute;
  bottom: -1px;
  left: 0;
  right: 0;
  height: 3px;
  background-color: #e74c3c;
}

.achievement-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 20px;
}

.achievement-item {
  cursor: pointer;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
}

.achievement-item:hover {
  transform: scale(1.05);
}

.achievement-item img {
  width: 100%;
  height: 280px;
  object-fit: cover;
}
.load-more { text-align: center; margin-top: 14px; }
.btn-outline { background: transparent; border: 2px solid var(--default-red-color); color: var(--default-red-color); padding: 10px 18px; border-radius: 6px; transition: all 0.25s ease; }
.btn-outline:hover { background: var(--default-red-color); color: #fff; }
.load-sentinel { height: 1px; }

/* 模态框样式 */
.photo-modal,
.achievement-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  position: relative;
  max-width: 90%;
  max-height: 90%;
}

.modal-content img,
.modal-content .responsive-preview {
  max-width: 100%;
  max-height: 80vh;
  display: block;
  border-radius: 4px;
  object-fit: contain;
}

.close-button {
  position: absolute;
  top: -40px;
  right: 0;
  color: white;
  font-size: 2rem;
  cursor: pointer;
  z-index: 1001;
}

.modal-caption {
  color: white;
  text-align: center;
  margin-top: 15px;
  font-size: 1.2rem;
}
.modal-fade-zoom-enter-active, .modal-fade-zoom-leave-active { transition: all .25s ease; }
.modal-fade-zoom-enter, .modal-fade-zoom-leave-to { opacity: 0; transform: scale(.98); }

/* 响应式调整 */
@media (max-width: 768px) {
  .banner-content h1 {
    font-size: 2.2rem;
  }

  .overview-cards {
    grid-template-columns: 1fr;
  }

  .photo-gallery,
  .achievement-grid {
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  }

  .achievement-item img {
    height: 220px;
  }
}

.our-achievements .achievements-timeline {
  position: relative;
  max-width: 800px;
  margin: 0 auto;
  padding-left: 40px;
}

.our-achievements .achievements-timeline::before {
  content: '';
  position: absolute;
  left: 15px;
  top: 0;
  bottom: 0;
  width: 4px;
  background-color: #e74c3c;
  border-radius: 2px;
}

.our-achievements .achievement-item {
  position: relative;
  margin-bottom: 25px;
  padding-left: 30px;
}

.our-achievements .achievement-year {
  position: absolute;
  left: 0px;
  top: 10px;
  width: 30px;
  height: 30px;
  background-color: #e74c3c;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.85rem;
  font-weight: bold;
}

.our-achievements .achievement-content {
  background-color: #fff5f5;
  padding: 15px 20px;
  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.08);
  font-size: 0.95rem;
  color: #333;
  line-height: 1.5;
}

</style>

